import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

const PRE_REGISTRATION_API_URL = `/api/pre-registration`;

@Injectable()
export class PreRegistrationBackend {
  constructor(private http: HttpClient) {}

  getPreRegistration(preRegistrationToken: string) {
    return this.http.get(`${PRE_REGISTRATION_API_URL}/${preRegistrationToken}`);
  }
}
